import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './iris/dashboard/dashboard.component';
import { AboutusComponent } from './iris/aboutus/aboutus.component';
import { SearchedBoardComponent } from './iris/searchedboard/searchedboard.component';
import { InfoDashboardComponent } from './iris/info-dashboard/info-dashboard.component';
import { VoiceDashboardComponent } from './iris/voice-dashboard/voice-dashboard.component';
import { VoiceArticleComponent } from './iris/voice-article/voice-article.component';
import { FacilityArticleComponent } from './iris/facility-article/facility-article.component';
import { KnowledgeDashboardComponent } from './iris/knowledge-dashboard/knowledge-dashboard.component';
import { SystemInfoComponent } from './iris/system-info/system-info.component';
import { ScholarshipComponent } from './iris/scholarship/scholarship.component';
import { TermsComponent } from './iris/terms/terms.component';
import { PrivacyComponent } from './iris/privacy/privacy.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'aboutus', component: AboutusComponent },
  { path: 'searchedboard', component: SearchedBoardComponent },
  { path: 'infoboard', component: InfoDashboardComponent },
  { path: 'voiceboard', component: VoiceDashboardComponent },
  { path: 'knowledgeboard', component: KnowledgeDashboardComponent },
  { path: 'facility', component: FacilityArticleComponent },
  { path: 'systeminfo', component: SystemInfoComponent },
  { path: 'scholarship', component: ScholarshipComponent },
  { path: 'voice', component: VoiceArticleComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'terms', component: TermsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy', onSameUrlNavigation: 'ignore' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
